module.exports = __webpack_public_path__ + "img/hr-heated-t-1.765aec7f.png";